<template>
  <header class="app-header" :class="{'is-clean':clean}" ref="globalHeader">
    <no-ssr>
      <affiliate-zone
        v-show="isShowAffiliate"
        :class="scrollDirection"
        :style="affiliateMarginTop">
      </affiliate-zone>
    </no-ssr>
    <nav class="header" @click="closeMenu" :style="marginTop" :class="scrollDirection">
      <div class="logo pos-absolute left">
        <logo :size="60"></logo>
      </div>

      <h2 class="sr-only">메인 메뉴</h2>
      <ul v-if="!clean" class="links inline">
        <li>
          <a
            :href="localePath('/')"
            :class="{'is-active':cityMenuMode=='trip'}"
            @click.prevent.stop="clickTripMenu('trip', $event)">
            {{ $t('common.navigation.trip') }}
          </a>
        </li>
        <li>
          <a :href="localePath('/product/flight-kr')">
            {{ $t('common.navigation.air') }}
          </a>
        </li>
        <!--<li>-->
          <!--<a-->
            <!--:href="localePath('/')"-->
            <!--:class="{'is-active':cityMenuMode=='accommodation'}"-->
            <!--@click.prevent="clickTripMenu('accommodation')">-->
            <!--{{ $t('common.navigation.accommodation') }}-->
          <!--</a>-->
        <!--</li>-->
        <li>
          <router-link :to.exact="{ path:localePath('/itinerary') }">
            {{ $t('common.navigation.itinerary') }}
          </router-link>
        </li>
        <li>
          <router-link :to.exact="{ path:localePath('/magazine') }">
            {{ $t('common.navigation.magazine') }}
          </router-link>
        </li>
        <li>
          <router-link :to.exact="{ path:localePath('/promotion') }">
            {{ $t('common.navigation.event') }}
          </router-link>
        </li>
      </ul>

      <div class="util-link pos-absolute right">
        <div class="util" v-if="!clean">
          <div>
            <language :class="{white: isWhite}" @opened="isOpened"/>
          </div>
          <div>
            <currencies :class="{white: isWhite}" @opened="isOpened"/>
          </div>
        </div>

        <span class="login" v-if="!clean">
          <no-ssr>
            <el-dropdown
              v-if="loggedUser"
              popperClass="profile"
              placement="bottom"
              width="40"
              trigger="click">

              <button class="profile">
                <user-photo
                  :src="loggedUser.photo"
                  alias="small"
                  size="40" />
              </button>

              <el-dropdown-menu slot="dropdown" class="type-header profile-list">
                <div class="menu-head" v-html="$t('common.user.greeting', {name:loggedUser.nick||loggedUser.name})" />
                <div class="menu-wrap none-padding">
                  <el-dropdown-item>
                    <router-link :to="localePath('/account/dashboard')">{{$t('meta.myPage')}}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item class="menu-line">
                    <router-link :to="localePath('/account/signout')">{{$t('common.button.logout')}}</router-link>
                  </el-dropdown-item>
                </div>
              </el-dropdown-menu>
            </el-dropdown>

            <router-link
              v-else
              :to="{path:loginPath}">
              {{ $t('common.button.login') }}
            </router-link>
          </no-ssr>
        </span>

        <span :class="['short-cut', {'is-border':!isLogged}]" v-if="!clean">
          <template v-if="loggedUser">
            <router-link
              type="button"
              class="flat notice"
              :to="localePath('/account/push-notification')"
              :title="$t('common.label.alert')">
                <i class="icon alert"/>
                <i class="icon alert-filled"/>
                <el-badge :value="loggedUser.alert||0"/>
            </router-link>
          </template>
          <button
             type="button"
             class="flat"
             :title="$t('common.button.search')"
             :aria-label="$t('common.button.search')"
             @click="searchOpen">
            <i class="icon search"/>
            <i class="icon search-filled"/>
          </button>
        </span>
      </div>
    </nav>
    <sub-menu
      :open="cityMenuOpen"
      :cityMenuMode="cityMenuMode"
      :openedMenu="openedMenu"
      @opened="isOpened"/>
    <search
      :visible="dialogVisible"
      @close="searchClose"/>
  </header>
</template>

<script>
  import TopBanner from 'views/components/top-banner';
  import Logo from 'views/components/logo';
  import Language from 'views/components/language';
  import Currencies from 'views/components/currencies';
  import SubMenu from './sub-menu';
  import Search from 'views/components/search';
  import AffiliateZone from 'views/components/affiliate-zone';
  import { mapActions } from 'vuex';
  import { getCookie } from "@/util/methods";

  import _throttle from 'lodash/throttle';

  export default {
    props: {
      clean: {
        type: Boolean,
        default: false,
      },
      defaultLayout: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      TopBanner,
      Logo,
      Language,
      Currencies,
      SubMenu,
      Search,
      AffiliateZone,
    },
    data () {
      return {
        openedMenu: null,
        cityMenuOpen: false,
        cityMenuMode: '',
        query: {},
        isWhite: true,
        isPopoverOpened: 0,
        dialogVisible: false,
        margin: 0,
        scrollDirection: '',
        topBanners: [],
        isShowAffiliate: false,
        affiliateMargin: 0,
      }
    },
    computed: {
      loginPath () {
        const query = this.$route.fullPath != '/' ? `?returnUrl=${this.$route.fullPath}` : '';
        return `/${this.$route.params.langCode}/account/signin${query}`;
      },
      marginTop () {
        return `margin-top:${this.margin}px`
      },
      affiliateMarginTop () {
        return `margin-top:${this.affiliateMargin}px`
      },
    },
    methods: {
      ...mapActions([ 'setHeaderHeight', 'setTopBanner' ]),
      clickTripMenu (mode, event) {
        if (mode == this.cityMenuMode && this.cityMenuOpen) {
          this.closeMenu();
        } else {
          this.openedMenu = event.target;
          this.cityMenuOpen = true;
          this.cityMenuMode = mode;
        }
      },
      isOpened (flag) {
        this.isPopoverOpened += flag ? 1 : -1;
        this.$emit('popoverOpened', this.isPopoverOpened)
      },
      closeMenu () {
        this.cityMenuOpen = false;
        this.cityMenuMode = '';
        this.openedMenu && this.openedMenu.focus();
        this.openedMenu = null;
      },
      searchClose() {
        this.$store.commit("SET_OPENED_SEARCH", false);
      },
      searchOpen() {
        this.$store.commit("SET_OPENED_SEARCH", true);
      }
    },
    watch: {
      '$route' () {
        this.closeMenu();
        this.margin = 0;
        this.affiliateMargin = 0;
      },
      '$store.state.openedSearch' ( flag ) {
        this.dialogVisible = flag
      }
      /*'cityMenuMode': function(val) {
        if (val == 'accommodation') {
          this.query = {type: 'accommodation'};
        } else {
          this.query = {};
        }
      }*/
    },
    mounted() {
      const hanacardReferralCode = (window && getCookie('affiliate_code')) || this.$route.query.a || null;
      const isHanacardReferral = hanacardReferralCode === 'MHJ-P-EXT190925000000';
      this.isShowAffiliate = this.defaultLayout && isHanacardReferral;

      let lastDirection, deferTimer, lastPosition = 0, changeDistance = 0;

      window.addEventListener('click', this.external = (e) =>{
        const el_globalHeader = this.$refs.globalHeader;
        //this.openedMenu = e.target;
        //console.log(this.$children)
        if( el_globalHeader && !this.clean ){
          if( e.target !== el_globalHeader && !el_globalHeader.contains(e.target) ){
            this.closeMenu();
          }
        }
      }, true);

      window.addEventListener('scroll', this.scrolling = _throttle(() => {
        const scroller = document.documentElement || window;
        const position = scroller.scrollTop;
        const direction = lastPosition > position ? 'UP' : 'DOWN';
        const headerHeight = this.$store.getters.topAffiliate + 90;
        if(direction !== lastDirection) {
          changeDistance = 0;
        } else {
          changeDistance += lastPosition - position;
        }
        lastPosition = position;
        lastDirection = direction;
        if(direction === 'DOWN') {
          this.scrollDirection = '';
          if(this.isShowAffiliate) {
            this.affiliateMargin = Math.max(changeDistance/1.2, -headerHeight);
          } else {
            this.margin = Math.max(changeDistance/2, -90);
          }
        } else if(changeDistance >= headerHeight/2) {
          this.scrollDirection = 'scroll-up';
          if(this.isShowAffiliate) {
            this.affiliateMargin = 0;
          } else {
            this.margin = 0;
          }
        }
        this.$store.commit('SET_HEADER_HEIGHT',this.$el.offsetHeight);
        clearTimeout(deferTimer);
        deferTimer = setTimeout(()=>{
          this.$store.commit('SET_HEADER_HEIGHT',this.$el.offsetHeight);
        },300)
      }, 3), false);
    },

    created(){
      // 2019.03.27 Top Banner 삭제 -> visual 영역으로 변경
      // this.$http.get('/contents/v1/banner/global-top').then((response)=>{
      //   let data = response.data;
      //   if(data.length){
      //     this.topBanners = response.data;
      //   }
      // })
    },
    destroyed() {
      this.margin = 0;
      this.affiliateMargin = 0;
      window.removeEventListener('scroll', this.scrolling);
      window.removeEventListener('click', this.external, true);
    }
  }
</script>

<style src="./style.scss" lang="scss" scoped></style>
